import { render } from "./SectionTechDistribution.vue?vue&type=template&id=fc6c6896&scoped=true"
import script from "./SectionTechDistribution.vue?vue&type=script&lang=js"
export * from "./SectionTechDistribution.vue?vue&type=script&lang=js"

import "./SectionTechDistribution.vue?vue&type=style&index=0&id=fc6c6896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6c6896"]])

export default __exports__